// ⌘B / Ctrl+B, the shortcut most apps with a collapsible sidebar have settled
// on. Rich text editors own it for bold, so it is declined while the cursor is
// in one.
export function isMenuShortcut(event: KeyboardEvent): boolean {
  if (!(event.metaKey || event.ctrlKey) || event.key !== 'b') return false

  const target = event.target
  return !(target instanceof Element && target.closest('trix-editor, [contenteditable]'))
}
